@if (message) {
<div class="message-block" [ngClass]="message.source + '-message'">
    <markdown [data]="message.markdownContent" (ready)="onMarkdownReady()"></markdown>
    <ng-content></ng-content>

    <ng-container *ngTemplateOutlet="isUserMessage() ? userExtras : assistantExtras; context: { $implicit: message.extras }"></ng-container>
</div>
}

<!-- #region Templates -->

<ng-template #userExtras let-extras>
    @if (asUserExtras(extras); as extras) { @if (extras.file) {
    <p-attachment-preview [file]="extras.file" [showRemoveButton]="false"></p-attachment-preview>
    } @if (extras.attachments?.length) {
    <div class="message-attachments">
        @for (attachment of extras.attachments; track attachment.resourceType + ':' + attachment.reference) {
        <p-attachment-preview
            [icon]="attachment.resourceType | attachmentIcon"
            [label]="attachment.label"
            [detail]="attachment.detail"
            [showRemoveButton]="false"
        ></p-attachment-preview>
        }
    </div>
    } }
</ng-template>

<ng-template #assistantExtras let-extras>
    @if (asAssistantExtras(extras); as extras) { @if (!!extras?.actionsSuggestions?.length) {
    <div class="actions-suggestions">
        @for (actionSuggestion of extras.actionsSuggestions; track actionSuggestion.label) {
        <p-button
            class="action-suggestion"
            [label]="actionSuggestion.label"
            [iconBefore]="actionSuggestion.icon"
            [isSentenceCase]="false"
            [buttonType]="buttonTypeEnum.Secondary"
            (click)="triggerActionSuggestionPrompt(actionSuggestion.label)"
        >
        </p-button>
        }
    </div>
    } @if (extras.links?.length) {
    <div class="extras assistant-links">
        <div class="p-headline-3">
            <p-icon name="arrow-down-right"></p-icon>
            {{ 'general.learn_more' | translate }}
        </div>

        @for (link of extras.links; track link) {
        <p-link [url]="linkPrefix + link + '?ai=on'">{{ link }}</p-link>
        }
    </div>
    } @if (!assistantWorking) {
    <p-like-dislike
        class="message-like-dislike"
        [feedbackMode]="extras.feedbackMode || 0"
        (feedbackClicked)="likeDislikeChanged($event, extras.messageId)"
    >
    </p-like-dislike>
    } @if (showFeedbackInteraction$ | async) {
    <user-feedback-interaction (selectedReasonChanged)="feedbackReasonChanged($event)" (textSubmitted)="feedbackTextSubmitted($event)">
    </user-feedback-interaction>
    } }
</ng-template>

<!-- #endregion -->
